import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { SubSink } from "subsink";
import { StringHelper } from "../../../utilities/contracts/string-helper";
import { DynamicControlDirective } from "../../dynamic-control-component.model";
import { FormService } from "../../form.service";
import { Switch } from "./switch.model";

@Component({
  selector: "form-switch",
  templateUrl: "./switch.component.html",
  styleUrls: ["./switch.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwitchComponent extends DynamicControlDirective<Switch> implements OnInit, OnDestroy {
  private sink = new SubSink();

  constructor(
    private readonly changeDetector: ChangeDetectorRef,
    private readonly formService: FormService
  ) {
    super();
  }

  ngOnInit() {
    this.sink.add(
      this.control.statusChanges.subscribe(() => this.formService.updateDom.next()),
      this.formService.updateDom.subscribe(() => this.changeDetector.markForCheck())
    );
  }

  ngOnDestroy() {
    this.sink.unsubscribe();
  }

  get hasSubLabel(): boolean {
    return StringHelper.isAvailable(this.model.subLabel);
  }

  get hasTooltip(): boolean {
    return StringHelper.isAvailable(this.model.tooltip);
  }

  get hasPreceedingOffLabel(): boolean {
    return StringHelper.isAvailable(this.model.preceedingOffLabel);
  }

  get hasFollowingOnLabel(): boolean {
    return StringHelper.isAvailable(this.model.followingOnLabel);
  }

  get classes(): string {
    return this.getClasses("switch");
  }

  onTooltipLoaded(text: string): void {
    this.model.tooltip = text;
    this.changeDetector.markForCheck();
  }

}
